/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Closed/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Closed({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Closed"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Closed.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}